var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    {
      attrs: { title: _vm.title, wrapperClass: "stats-card " + _vm.customClass }
    },
    [
      _c("div", { staticClass: "text-3xl font-bold" }, [
        _vm._v(_vm._s(_vm.value))
      ]),
      _vm._v(" "),
      _c("div", { class: "text-sm " + _vm.changeColor }, [
        _vm._v(_vm._s(_vm.changeText))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70b5cec0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70b5cec0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/StatCards/StatCard.vue
// module id = null
// module chunks = 